import React from "react";
import Button from "antd/lib/button";
import ZIcon from "../ZIcon";
import { IButtonProps, EIconSizes } from "./interface";

import "./index.less";

const ZButton = React.forwardRef<HTMLElement | null, IButtonProps>(
	(
		{
			className = "",
			iconName = "",
			iconPlacement = "left",
			size = "middle",
			iconSize = size,
			iconButton,
			iconProps,
			...rest
		},
		ref
	) => (
		<Button
			data-cke-ignore-events="true"
			className={`z-button ${className} ${`z-button-${iconPlacement}-icon`} ${
				iconButton ? "z-icon-button" : ""
			}`}
			icon={
				iconName && (
					<ZIcon
						name={iconName}
						size={EIconSizes[iconSize]}
						{...iconProps}
					/>
				)
			}
			size={size}
			ref={ref}
			{...rest}
		/>
	)
);

export default ZButton;
